import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PublicService } from '../../../services/public.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LogService } from '../../../services/log.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'primeng/tabs';
import { timer } from 'rxjs';
import { Team } from '../../../models/team';

@Component({
  selector: 'app-public-rounds',
  imports: [
    CommonModule,
    FormsModule,
    SelectModule,
    TabsModule,
    TranslatePipe,
  ],
  templateUrl: './public-rounds.component.html',
  styleUrl: './public-rounds.component.scss',
})
export class PublicRoundsComponent implements OnInit, AfterViewInit {
  @Input() tournamentIdInput: string | undefined;

  private readonly destroy$ = inject(DestroyRef);
  public playoffs: any = {};
  public rounds: any[] = [];
  private tournamentId: string = '';

  constructor(
    private cdr: ChangeDetectorRef,
    private logService: LogService,
    private publicService: PublicService,
    private route: ActivatedRoute,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.tournamentId = this.tournamentIdInput || this.route.snapshot.paramMap.get('id')!;
    // get matches once per minute
    timer(0, 60000).subscribe(() => {
      this.getMatches(this.tournamentId);
    });
  }

  ngAfterViewInit(): void {
    // wait for DOM to be printed
    setTimeout(() => this.sendHeight(), 100);
    // resize if content changes
    const observer = new ResizeObserver(() => this.sendHeight());
    observer.observe(document.body);
  }

  private getMatches(tournamentId: string): void {
    this.rounds = [];
    this.publicService.getPublicMatches(tournamentId).pipe(takeUntilDestroyed(this.destroy$)).subscribe({
      next: (res) => {
        this.logService.debug('[Rounds] - getPublicMatches', res);
        // rounds
        this.rounds = Object.entries(_.get(res, 'body.data.rounds')).map(([key, matches]) => ({
          round: Number(key),
          groups: _.orderBy(_.map(_.groupBy(matches || [], 'group.id'), (matches, groupId) => {
            return {
              group: {
                groupId, 
                name: `${this.translate.instant('field.group')} ${_.get(_.first(matches), 'group.name')}`
              }, 
              matches: _.orderBy(matches, 'tableNumber')
            }
          }), 'group.name')
        }));
        // playoffs
        _.forOwn(_.get(res, 'body.data.playoffs'), (matches, playoffRound) => {
          _.set(this.playoffs, playoffRound, {
            official: _.filter(matches, {type: 'OFFICIAL'}),
            positioning: _.filter(matches, {type: 'POSITIONING'}),
            consolation: _.filter(matches, {type: 'CONSOLATION'}),
          });
        });
        // set wrapper height
        this.sendHeight();
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.logService.error('[Rounds] - getPublicMatches', err, this.translate.instant('error.round-matches'));
      }
    });
  }

  private sendHeight(): void {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ iframeRoundsHeight: height }, '*');
  }
}
